import { RequestError } from '@swf/core/errors/RequestError';

export const hasRequestAborted = (error: unknown) =>
  error instanceof RequestError && error.body.code === 'ABORT_ERROR';
